import { h } from 'preact';

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const USPRow = props => {
  const uspOne = props.uspOne ? props.uspOne : '';
  const uspTwo = props.uspTwo ? props.uspTwo : '';
  const uspThree = props.uspThree ? props.uspThree : '';

  return (
    <div className="c-shop-usps u-flex">
      <div className="c-shop-usps__usp u-flex u-flex-v-center">
        <svg className="c-icon c-shop-usps__icon">
          <use href="#check-v2" xlinkHref="#check-v2" />
        </svg>

        <div dangerouslySetInnerHTML={{__html: uspOne}}/>
      </div>

      {uspTwo ? (
        <div className="c-shop-usps__usp u-flex u-flex-v-center">
          <svg className="c-icon c-shop-usps__icon">
            <use href="#check-v2" xlinkHref="#check-v2" />
          </svg>

          <div dangerouslySetInnerHTML={{__html: uspTwo}}/>
        </div>
      ) : false }

      {uspThree ? (
        <div className="c-shop-usps__usp u-flex u-flex-v-center">
          <svg className="c-icon c-shop-usps__icon">
            <use href="#check-v2" xlinkHref="#check-v2" />
          </svg>

          <div dangerouslySetInnerHTML={{__html: uspThree}}/>
        </div>
      ) : false }
    </div>
  );
};

export default USPRow;


// WEBPACK FOOTER //
// ./src/js/shop/components/USPRow.js